module.exports = __webpack_public_path__ + "static/media/engagement-rate.dd681f4b.svg";